import { useEffect, useRef, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { formatError } from '@/lib/api';
import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function VerifyAccess() {
  const { user, loading, verifyMfa, logout } = useAuth();
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const pending = useRef(null);
  useEffect(() => () => pending.current?.abort(), []);
  if (loading) return <p className="p-8">Verificando acceso…</p>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.mfa_required) return <Navigate to={user.must_change_password ? '/change-password' : '/app'} replace />;
  async function submit(event) {
    event.preventDefault();
    if (pending.current) return;
    const controller = new AbortController();
    pending.current = controller;
    setBusy(true); setError('');
    try {
      const verified = await verifyMfa(code.trim(), user.id, controller.signal);
      if (!verified || verified.mfa_required) throw new Error('No se pudo confirmar el acceso');
      navigate(verified.must_change_password ? '/change-password' : '/app', { replace: true });
    } catch (err) { if (!controller.signal.aborted) setError(formatError(err.response?.data?.detail || err.message)); }
    finally { pending.current = null; if (!controller.signal.aborted) { setCode(''); setBusy(false); } }
  }
  return <main className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-5">
    <Logo size="lg" variant="compact" className="mb-6" />
    <form onSubmit={submit} className="w-full max-w-md rounded-2xl border border-neutral-800 bg-[#0D0D0D] p-6 space-y-4">
      <h1 className="text-xl font-bold">Verificar mi acceso</h1>
      <p className="text-sm text-neutral-400">Escribe el código de tu autenticador o uno de tus códigos de recuperación.</p>
      <label htmlFor="mfa-code" className="block text-sm">Código</label>
      <Input id="mfa-code" required maxLength={32} autoComplete="one-time-code" value={code} disabled={busy} onChange={e => setCode(e.target.value)} />
      {error && <p role="alert" className="text-red-300">{error}</p>}
      <Button className="w-full bg-[#E63946]" type="submit" disabled={busy}>{busy ? 'Verificando…' : 'Continuar'}</Button>
      <button type="button" disabled={busy} className="min-h-[44px] underline w-full" onClick={() => logout()}>Cerrar sesión</button>
    </form>
  </main>;
}

